import c from "classnames";

import classes from "./CardFooter.module.css";

type Props = {
  children: React.ReactNode;
  border?: boolean;
  justify?: "start" | "end" | "center";
  gap?: number;
};

export const CardFooter = ({
  children,
  border,
  justify = "end",
  gap = 8,
}: Props) => {
  return (
    <footer
      className={c(
        classes.footer,
        border && classes.border,
        justify && classes[justify],
      )}
      style={{ gap: `${gap}px` }}
    >
      {children}
    </footer>
  );
};
